import { request as __request } from "../core/request";

export enum DocumentStatus {
    PENDING = "pending",
    COMPLETED = "completed",
}

export interface DocuSealDocument {
    envelopeId: number;
    userId: number;
    propertyId: number;
    projectId: number;
    status: DocumentStatus;
    url: string;
    downloadUrl: string | null;
    projectName: string;
    name: string;
    templateId?: number | null;
    contractType?: string | null;
}

export interface DocuSealRequest {
    email: string;
    templateId: number;
    propertyId?: number;
    projectId?: number;
    fields: {
        projectName: string;
    };
}

export interface DocuSealTemplateResponse {
    id: number;
    templateId: number;
    projectId: number;
    resourceId: number;
}

export const DocuSealService = {
    getDocuments: async (
        email: string,
        projectId?: number,
        status?: DocumentStatus,
    ): Promise<DocuSealDocument[]> => {
        const response = await __request({
            method: "GET",
            path: `/api/docuseal`,
            query: {
                email,
                projectId,
                status,
            },
        });
        return response as DocuSealDocument[];
    },

    createDocuments: async (
        templateId: string,
        email: string,
    ): Promise<DocuSealDocument> => {
        const response = await __request({
            method: "POST",
            path: `/api/docuseal/documents`,
            body: {
                templateId,
                email,
            },
        });
        return response as DocuSealDocument;
    },

    createTemplate: async (
        projectId: number,
        resourceId: number,
    ): Promise<DocuSealTemplateResponse> => {
        const response = await __request({
            method: "POST",
            path: `/api/docuseal/templates`,
            body: {
                projectId,
                resourceId,
            },
        });
        return response as DocuSealTemplateResponse;
    },
};
